<div class="chart-output-module-container">
    <app-header-nav-bar style="--nav-header-img: url('/assets/images/common/Header.svg')">
        <app-header-nav-text></app-header-nav-text>
        <app-header-home [moduleName]="'snapshot'"></app-header-home>
    </app-header-nav-bar>
    <!-- <app-chart-header [chartDisplayName]="chartDisplayName" (backBtnClick)="goBackToChartSelection($event)">
    </app-chart-header> -->
    <div class="chart-output-main-header"><span class="back-btn" (click)="goback()"> <img class="back-btn"
                alt="backbutton" src="../../../../assets/ImagesSnapshot/Public/Back_icon.svg"> </span>
        <div _ngcontent-yxy-c40="" class="header_text">{{chartTitle}}</div>
    </div>
    <div class="chart-ouptut-body-container">
        <div class="chart-output-div">
            <div class="chart-output-header">
                <div class="output-txt">{{widgetTitleText}}</div>
            </div>
            <div class="chart-output-body">
                <!-- <div class="widgetTitleText">{{widgetTitleText}}</div> -->
                <div class="chart-output">
                    <router-outlet></router-outlet>
                </div>
                <div class="buttons">
                    <div class="wrapper">
                        <div class="save-btn  CP" (click)="saveCurrentWidget()">
                            <span class="arrow-down"><img _ngcontent-jbe-c35=""
                                    src="../../../../assets/images/common/Icon_Save.svg" alt="Save" class="ng-tns-c35-1"
                                    style="width:3vh;height:3vh;margin-top: 0vh;margin-right: 0.5vh;top:1vh"></span><span>Save</span>
                        </div>
                    </div>
                    <!-- <div class="wrapper">
                        <div class="download-btn CP">
                            <span class="arrow-down"><img _ngcontent-qgf-c35="" src="../../../../assets/ImagesSnapshot/Public/Icon_load.svg" alt="Submit" class="ng-tns-c35-0" style="width:3vh;height:3vh;margin-top: 0vh;margin-right: 0.5vh;top:1vh"></span><span>Submit</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="chart-description-container">
            <div class="chart-description-header" [style]="'height:3.6vh'">
                <div class="chart-description-header-txt">CUSTOMIZATION</div>
                <!-- <div class="toggle-container" *ngIf="showToggle">
            <span>Solid</span>
            <div class="toggle" [ngClass]="solidOrPattern ? 'toggle-right' : 'toggle-left'" (click)="toggleClick()"></div>
            <span>Pattern</span>
          </div> -->
            </div>
            <div class="parent-customization-container">
                <div class="checkboxes-container">
                    <div class="input-div" *ngFor="let item of items; let i = index" style="display: flex;"
                        [style]="item.inputType!='checkbox'?(item.inputType === 'text'||'textArea'?'flex-direction: unset;':'flex-direction: column;'):'display:none'">
                        <ng-container  *ngIf="item.inputType === 'checkboxlist'&& item.id !== 'Audience Drop down'&& item.id !== 'Brand Drop down'">
                            <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'"
                                [class.disabled]="isBrandDependent === false"
                                [style.pointer-events]="isBrandDependent === false ? 'none' : 'auto'"
                                [style.opacity]="isBrandDependent === false ? '0.5' : '1'">
                                <div
                                    style="display:flex;flex-direction: column;width:41.5%;margin-right: 3px;">
                                    <label style="width:100%"[class.disabled]="isBrandDependent === false" >{{item.customization}}</label>
                                    <p style="font-size:0.5rem;margin-left:1%" *ngIf="item.maxMetricLimit>1 && item.maxMetricLimit!=10000">(Max Metric
                                        Select : {{item.maxMetricLimit}})</p>
                                </div>
                                <div style="position:relative;display: inline-block;width: 54%;" [class.disabled]="isBrandDependent === false">
                                    <!-- (mouseleave)="item.showDropdown = false" -->
                                    <!-- (mouseleave)="toggleMetricDropdown(item)" -->
                                    <div (mouseleave)="isBrandDependent !== false && toggleMetricDropdown(item,true)">
                                        <button class="drop-toggle btn flat" (click)="isBrandDependent !== false && toggleMetricDropdown(item,false) "  [disabled]="isBrandDependent === false"
                        [class.disabled]="isBrandDependent === false">
                                            <span class="selectText" *ngIf="item.checkedList.length<=0">Select</span>
                                            <span class="selectText"
                                                *ngIf="item.checkedList.length==1">{{item.checkedList[0].option}}</span>
                                            <span class="selectText"
                                                *ngIf="item.checkedList.length>1">{{"Multiple"}}</span>
                                            <p class="fa"><img class="downarrow"
                                                    src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
                                        </button>
                                        <!-- (click)="resetmetricselections(row.widgetNumber,i.subWidgetName,row.metric,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,pageCounter,i,'')" -->
                                        <!-- <div class="drop-show"
                                            *ngIf="item.showDropdown && (item.select==1 || item.select==2)">
                                            <div class="search-reset">
                                                <div class="sub-items-search">
                                                    <input class="searchinput" type="text" placeholder="Search"
                                                        [(ngModel)]="searchmetric" autocomplete="off"
                                                        name="searchmetric" />
                                                    <div class="search-icon">
                                                        <div class="search-icon-image"></div>
                                                    </div>
                                                </div>
                                                <div class="reset-button" (click)="resetSelections(item,item.options)">
                                                    -------------
                                                    <div class="resetbtn"></div>
                                                </div>
                                            </div>
                                            <label *ngFor="let a of item.options|searchchartoutput:searchmetric"
                                                class="metricLabels">
                                                <div class="select_number"
                                                    [style]="item.select==1?'display:none':'display:block'"
                                                    *ngIf="a.option!=''">
                                                    {{a.selectOrder>0?a.selectOrder:" "}}
                                                </div>
                                                <input [type]="item.select==1?'radio':'checkbox'"
                                                    [disabled]="item.checkedList.length>=item.maxMetricLimit && !a.checked && item.maxMetricLimit>0 && item.select!=1"
                                                    [checked]="a.checked!=null?a.checked:false"
                                                    (change)="getSelectedValue(a,a.option,item)" />
                                                <span class="metricLabelOption"
                                                    [class.disabled]="item.checkedList.length>=item.maxMetricLimit && !a.checked &&  item.maxMetricLimit>0 && item.select!=1"
                                                    [title]="a.option">{{a.option}}</span>
                                            </label>
                                        </div> -->
                                        <!-- <div class="drop-show" *ngIf="item.showDropdown && item.select==3"> -->
                                        <div class="drop-show" *ngIf="item.showDropdown && isBrandDependent !== false">
                                            <div class="metricLev1" [ngClass]="lev1.isDropdownOpen?'border':''"
                                                *ngFor="let lev1 of item.options">
                                                <div class="custom-select-lev1"
                                                    *ngIf="lev1.option!=''">
                                                    <div class="level1-name" [title]="lev1.option"
                                                        (click)="togglemetriclev1Dropdown(item.options,lev1)">
                                                        {{lev1.option}}
                                                    </div>
                                                    <div class=" arrow1"
                                                        (click)="togglemetriclev1Dropdown(item.options,lev1)">
                                                        <div class="arrowToggle arrowCollapsedIcon"></div>
                                                    </div>
                                                </div>
                                                <div class="search-reset" *ngIf="lev1.isDropdownOpen">
                                                    <div class="sub-items-search">
                                                        <input class="searchinput" type="text" placeholder="Search"
                                                            [(ngModel)]="searchmetric" autocomplete="off"
                                                            name="searchmetric" />
                                                        <!-- (ngModelChange)="filterOptions(i,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,row.metric.metric_select)"  -->
                                                        <div class="search-icon" style="top:18.5% !important">
                                                            <div class="search-icon-image"></div>
                                                        </div>
                                                    </div>
                                                    <div class="reset-button"
                                                        (click)="resetSelections(item,item.options,lev1)">
                                                        <!-- (click)="resetmetricselections(row.widgetNumber,i.subWidgetName,row.metric,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,pageCounter,i,'')" -->
                                                        <div class="resetbtn"></div>
                                                    </div>
                                                </div>
                                                <div class="custom-options-lev2" *ngIf="lev1.isDropdownOpen">
                                                    <div class="metricLev2"
                                                        *ngFor="let lev2 of lev1.Level2|searchchartoutput:searchmetric">
                                                        <div class="level2-container"
                                                            [ngClass]="lev2.isSelected?'selectedDropdownItem':''">
                                                            <div class="select_number"
                                                                [style]="lev1.type=='radio'?'display:none':'display:block'"
                                                                *ngIf="lev2.option!='' && lev1.option!=='METRIC GROUP'">
                                                                {{lev2.selectOrder>0?lev2.selectOrder:" "}}
                                                            </div>
                                                            <div class="checkbox-container" *ngIf="lev2.option!=''">
                                                                <input [id]="lev2.option" [type]="lev1.type"
                                                                    [name]="lev1.type=='radio' ? item.id + '_' + lev1.option : lev2.option"
                                                                    class="checkbox" [checked]="item.select==1 ? lev2.checked != undefined && lev2.checked != null ? lev2.checked : false : lev2.isSelected"
                                                                    (change)="getSelectedValue(lev2,lev2.option,item,lev1)"
                                                                    [class.disabled]="item.select != 1 && lev1.type!='radio' && item.maxMetricLimit!=0 && item.maxMetricLimit!=-1 && item.maxMetricLimit!=0 && (item.checkedList.length>=item.maxMetricLimit && !lev2.isSelected)" />
                                                                <!-- (click)="metriccheckboxchecked($event,row,lev2,i,lev1,pageCounter)"  -->
                                                            </div>
                                                            <label class="level2-name" [for]="lev2.option"
                                                                [class.disabled]="item.select != 1 && lev1.type!='radio' && item.maxMetricLimit!=0 && item.checkedList.length>=item.maxMetricLimit && !lev2.isSelected"
                                                                [title]="lev2.option">{{lev2.option}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="item.inputType === 'customdropdown'">
                            <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                            [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                            <div
                                style="display:flex;flex-direction: column;width:40%;margin-left: 5px;margin-right: 5px;">
                                <label style="width:100%">{{item.customization}}</label>
                            </div>
                            <div style="margin-right:20px;position:relative;display: inline-block;width: 54%;">
                                <!-- (mouseleave)="item.showDropdown = false" -->
                                <!-- (mouseleave)="toggleMetricDropdown(item)" -->
                                <div >
                                    <button class="drop-toggle btn flat" (click)="toggleMetricDropdown(item,false)">
                                        <span class="selectText">{{item.selectedValue}}</span>
                                        <p class="fa"><img class="downarrow"
                                                src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
                                    </button>
                                  
                                    <div class="drop-show" *ngIf="item.showDropdown">
                                        <div class="metricLev1" 
                                            *ngFor="let lev1 of item.options">
                                            <div class="custom-select-lev1" *ngIf="lev1.option!=''">
                                                <input type="radio" [checked]="lev1.isSelected" (click)="cutomDropdownClick(item,lev1,$event)" >
                                                <div class="level1-name" [title]="lev1.option" (click)="cutomDropdownClick(item,lev1,$event);">
                                                    {{lev1.label}}
                                                </div>
                                                <div class=" arrow1" *ngIf="lev1.inputType=='colorpicker'">
                                                    <input type="color" id="{{item.customization}}" class="color-option"
                                    [class.disabled]="!lev1.isSelected" style="width: 1.8em; height: 2em;margin-bottom:0.2em;border:0; cursor: pointer;"
                                    (change)="loadedComponent[item.func]($event,lev1.id+'color')" [value]="lev1.color">
                                                </div>
                                            </div>
                                            <div class="metricLev1" *ngIf="lev1.options && lev1.options.length>0 && lev1.isSelected">
                                                <div class="custom-select-lev1" style="padding-top: 1%;padding-bottom: 4%;" *ngFor="let lev2 of lev1.options">
                                                <div class="level1-name" [title]="lev2.label">
                                                    {{lev2.label}}
                                                </div>
                                                <div class=" arrow1" *ngIf="lev2.inputType=='colorpicker'">
                                                    <input type="color" id="{{item.customization}}" class="color-option"
                                                     style="width: 1.8em; height: 2em;margin-bottom:0.2em;border:0; cursor: pointer;"
                                                     (change)="loadedComponent[item.func]($event,item.id)" [value]="item.value">
                                                </div>
                                                <div class=" arrow1" style="width: 56%;justify-content: right !important;gap: 5%;" *ngIf="lev2.inputType=='textbox-colorpicker'">
                                                    <input type="text"  id="{{item.customization}}" [(ngModel)]="lev2.inputvalue" (change)="loadedComponent[item.func]($event,lev2.id+'text')"
                                                    [placeholder]="lev2.placeholder" maxlength="30" class="dropdown">
                                                    <input type="color" id="{{item.customization}}" class="color-option"
                                                     style="width: 1.8em; height: 2em;margin-bottom:0.2em;border:0; cursor: pointer;"
                                                     (change)="bipsColorChange($event,lev2,item)" [value]="lev2.color">
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        </ng-container>
                       

<!-- Audience Drop down - disabled when Brand Dependent -->
<!-- Additional KPI Drop down - similar to Metric but with radio buttons -->
<ng-container *ngIf="item.inputType === 'radio' && item.id === 'Additional KPI'">
    <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
        [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
        <div style="display:flex;flex-direction: column;width:41.5%;margin-right: 3px;">
            <label style="width:100%">{{item.customization}}</label>
            <p style="font-size:0.5rem;margin-left:1%">
                (Single Selection)
            </p>
        </div>
        <div style="position:relative;display: inline-block;width: 54%;">
            <div (mouseleave)="toggleMetricDropdown(item,true)">
                <button class="drop-toggle btn flat" (click)="toggleMetricDropdown(item,false)">
                    <span class="selectText" *ngIf="!item.checkedList || item.checkedList.length<=0">Select</span>
                    <span class="selectText"
                        *ngIf="item.checkedList && item.checkedList.length==1">{{item.checkedList[0].option}}</span>
                    <span class="selectText"
                        *ngIf="item.checkedList && item.checkedList.length>1">{{item.checkedList.length}} Selected</span>
                    <p class="fa"><img class="downarrow"
                            src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
                </button>
                
                <div class="drop-show" *ngIf="item.showDropdown">
                    <div class="metricLev1" [ngClass]="lev1.isDropdownOpen?'border':''"
                        *ngFor="let lev1 of item.options">
                        <div class="custom-select-lev1" *ngIf="lev1.option!=''">
                            <div class="level1-name" [title]="lev1.option"
                                (click)="togglemetriclev1Dropdown(item.options,lev1)">
                                {{lev1.option}}
                            </div>
                            <div class="arrow1"
                                (click)="togglemetriclev1Dropdown(item.options,lev1)">
                                <div class="arrowToggle arrowCollapsedIcon"></div>
                            </div>
                        </div>
                        <div class="search-reset" *ngIf="lev1.isDropdownOpen">
                            <div class="sub-items-search">
                                <input class="searchinput" type="text" placeholder="Search"
                                    [(ngModel)]="searchAdditionalKPI" autocomplete="off"
                                    name="searchAdditionalKPI" />
                                <div class="search-icon" style="top:18.5% !important">
                                    <div class="search-icon-image"></div>
                                </div>
                            </div>
                            <div class="reset-button"
                                (click)="resetSelections(item,item.options,lev1)">
                                <div class="resetbtn"></div>
                            </div>
                        </div>
                        <div class="custom-options-lev2" *ngIf="lev1.isDropdownOpen">
                            <div class="metricLev2"
                                *ngFor="let lev2 of lev1.Level2|searchchartoutput:searchAdditionalKPI">
                                <div class="level2-container"
                                    [ngClass]="lev2.isSelected?'selectedDropdownItem':''">
                                    <div class="checkbox-container" *ngIf="lev2.option!=''">
                                        <input [id]="'kpi_' + lev2.option" 
                                            type="radio"
                                            name="additionalKPI"
                                            class="checkbox" 
                                            [checked]="lev2.isSelected != undefined && lev2.isSelected != null ? lev2.isSelected : (lev2.checked || false)"
                                            (change)="getSelectedValue(lev2,lev2.option,item,lev1)" />
                                    </div>
                                    <label class="level2-name" 
                                        [for]="'kpi_' + lev2.option"
                                        [title]="lev2.option">{{lev2.option}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="item.inputType === 'checkboxlist' && item.id === 'Audience Drop down'">
    <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
        [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
        <div style="display:flex;flex-direction: column;width:41.5%;margin-right: 3px;">
            <label style="width:100%" [class.disabled]="isBrandDependent === true">{{item.customization}}</label>
            <p style="font-size:0.5rem;margin-left:1%" *ngIf="item.maxAudienceLimit > 1">
                (Max Audience Select : {{item.maxAudienceLimit}})
            </p>
        </div>
        <div style="position:relative;display: inline-block;width: 54%;">
            <div (mouseleave)="isBrandDependent !== true && toggleAudienceDropdown(item,true)">
                <button class="drop-toggle btn flat" 
                        (click)="isBrandDependent !== true && toggleAudienceDropdown(item,false)"
                        [disabled]="isBrandDependent === true"
                        [class.disabled]="isBrandDependent === true">
                    <span class="selectText" *ngIf="item.checkedList.length<=0">Select</span>
                    <span class="selectText" *ngIf="item.checkedList.length==1">{{item.checkedList[0].option}}</span>
                    <span class="selectText" *ngIf="item.checkedList.length>1">Multiple</span>
                    <p class="fa"><img class="downarrow"
                            src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
                </button>
                
                <div class="drop-show" *ngIf="item.showDropdown && isBrandDependent !== true">
                    <div class="search-reset">
                        <div class="sub-items-search">
                            <input class="searchinput" type="text" placeholder="Search"
                                [(ngModel)]="searchAudience" 
                                autocomplete="off"
                                name="searchAudience" />
                            <div class="search-icon">
                                <div class="search-icon-image"></div>
                            </div>
                        </div>
                        <div class="reset-button" (click)="resetAudienceSelections(item,item.options)">
                            <div class="resetbtn"></div>
                        </div>
                    </div>
                    
                    <label *ngFor="let audience of item.options | searchchartoutput : searchAudience"
                        class="metricLabels">
                        <span [style.margin-right.px]="3" 
                              *ngIf="audience.is_selected && audience.selectOrder" 
                              class="selection-order">{{audience.selectOrder}}</span>

                        <input type="checkbox"
                            [checked]="audience.is_selected != null ? audience.is_selected : false"
                            [disabled]="!audience.is_selected && item.checkedList.length >= item.maxAudienceLimit && item.maxAudienceLimit > 0"
                            (change)="getSelectedAudienceValue(audience, audience.option, item)" />
                        <span class="metricLabelOption"
                            [class.disabled]="!audience.is_selected && item.checkedList.length >= item.maxAudienceLimit && item.maxAudienceLimit > 0"
                            [title]="audience.option">{{audience.option}}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Brand Drop down - enabled when Brand Dependent -->
<ng-container *ngIf="false && item.inputType === 'checkboxlist' && item.id === 'Brand Drop down'">
    <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
        [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
        <div style="display:flex;flex-direction: column;width:41.5%;margin-right: 3px;">
            <label style="width:100%" [class.disabled]="isBrandDependent === false">{{item.customization}}</label>
        </div>
        <div style="position:relative;display: inline-block;width: 54%;">
            <div (mouseleave)="isBrandDependent !== false && toggleAudienceDropdown(item,true)">
                <button class="drop-toggle btn flat" 
                        (click)="isBrandDependent !== false && toggleAudienceDropdown(item,false)"
                        [disabled]="isBrandDependent === false"
                        [class.disabled]="isBrandDependent === false">
                    <span class="selectText" *ngIf="item.checkedList.length<=0">Select</span>
                    <span class="selectText" *ngIf="item.checkedList.length==1">{{item.checkedList[0].option}}</span>
                    <span class="selectText" *ngIf="item.checkedList.length>1">Multiple</span>
                    <p class="fa"><img class="downarrow"
                            src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
                </button>
                
                <div class="drop-show" *ngIf="item.showDropdown && isBrandDependent !== false">
                    <div class="search-reset">
                        <div class="sub-items-search">
                            <input class="searchinput" type="text" placeholder="Search"
                                [(ngModel)]="searchBrand" 
                                autocomplete="off"
                                name="searchBrand" />
                            <div class="search-icon">
                                <div class="search-icon-image"></div>
                            </div>
                        </div>
                    </div>
                    
                    <label *ngFor="let audience of item.options | searchchartoutput : searchBrand"
                        class="metricLabels">
                        <input type="radio"
                            name="brandRadio"
                            [checked]="audience.is_selected != null ? audience.is_selected : false"
                            (change)="getSelectedAudienceValue(audience, audience.option, item)" />
                        <span class="metricLabelOption"
                            [title]="audience.option">{{audience.option}}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</ng-container>

                        <ng-container *ngIf="item.inputType === 'text' && item.customization === 'Widget Name : '">
                            <div style="display:inherit;flex-direction:unset;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                                <label class="input-div" for="{{item.customization}}"
                                    [innerHTML]="getCustomization(item)"></label>
                                <input type="text" id="{{item.customization}}" [(ngModel)]="widgetTitleText"
                                    [placeholder]="widgetTitleText" maxlength="30" class="dropdown">
                            </div><br>
                        </ng-container>
                        <ng-container *ngIf="item.inputType === 'text' && item.customization !== 'Widget Name : ' && shouldShowFixedValueInput(item)">
                            <div style="display:inherit;flex-direction:unset;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                                <label class="input-div" for="{{item.customization}}"
                                    [innerHTML]="getCustomization(item)"></label>
                                <input type="number" id="{{item.customization}}" [(ngModel)]="item.value"
                                    [placeholder]="item.customization" class="dropdown"
                                    (change)="callCustomization($event, item)">
                            </div><br>
                        </ng-container>
                        <ng-container *ngIf="item.inputType === 'OutsideCheckbox'">
                            <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                                <div class="item-container1">
                                    <input type="checkbox" class="checkbox-radio" id="{{item.customization}}"
                                        (click)="OutsidecheckBoxesClicked($event,item)" [checked]="item.checked||item.selectedValue">
                                    <label for="{{item.customization}}" (click)="OutsidecheckBoxesClicked($event,item)" 
                                        class="checkbox-label">{{item.customization.replace(" : ","")}}</label><br>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="item.inputType === 'color'"
                            [style]="i%2==0?'background-color:grey':'background-color:transparent'">
                            <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                                <div style="display:flex;flex-direction: column;width:50%">
                                    <label style="width:100%" for="{{item.customization}}"
                                        [class.disabled]="datalabelpattern.test(item.className)?isdatalabel:(legendpattern.test(item.className)?islegend:FirstColumnpattern.test(item.className)?isFirstColumn:FirstRowpattern.test(item.className)?isFirstRow: null)"
                                        [innerHTML]="getCustomization(item)"></label>
                                    <p style="font-size:0.5rem;margin-left:1%">(Colour Picker)</p>
                                </div>
                                <input type="color" id="{{item.customization}}" class="color-option"
                                    [class.disabled]="datalabelpattern.test(item.className)?isdatalabel:(legendpattern.test(item.className)?islegend:FirstColumnpattern.test(item.className)?isFirstColumn:FirstRowpattern.test(item.className)?isFirstRow: null)"
                                    style="width: 1.8em; height: 2em;margin-bottom:0.2em;border:0; cursor: pointer;"
                                    (change)="loadedComponent[item.func]($event,item.id)" [value]="item.value">
                            </div>
                        </ng-container>
                        <ng-container *ngIf="item.inputType === 'images'">
                            <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                                <label for="{{item.customization}}" class="labelName"
                                    [class.disabled]="datalabelpattern.test(item.className)?isdatalabel:(legendpattern.test(item.className)?islegend: null)"
                                    style="font-family: 'KantarBrown-Regular', sans-serif;"
                                    [innerHTML]="getCustomization(item)"></label>
                                <div class="Images" style="display: flex;align-items: center;">
                                    <div class="{{img.imgClassName}}" [attr.value]="img.value"
                                        [class.disabled]="shouldDisableImage(item, img)"
                                        (click)="imgOnClick(img,$event,item);updateitems(item,$event);"
                                        *ngFor="let img of item.options"
                                        [ngClass]="img.selected?img.selectedImgClassName:img.imgClassName"
                                        style="cursor: pointer;"></div>
                                </div>
                            </div>
                        </ng-container>
                      <ng-container *ngIf="item.inputType === 'toggle'"
    [style]="i%2==0?'background-color:grey':'background-color:transparent'">
    <div style="display:inherit;align-items: center;width:100%;padding-top:2vh;padding-bottom:2vh"
        [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
        <label for="{{item.customization}}" class="labelName"
            [innerHTML]="getCustomization(item)"></label>
        <div class="label-toggle-container" style="cursor: pointer;">
            <span *ngFor="let img of item.options">
                <span class="toggleon" [class]="img.value"
                    [style]="img.selected?'background-color:#812ab7;color:white':'background-color:transparent;color:black'"
                    [attr.value]="getToggleValue(item)"
                    [ngClass]="getToggleClass(item)"
                    (click)="toggleClick(item, img, $event)">{{img.label}}</span>
            </span>
        </div>
    </div>
</ng-container>
                        <ng-container *ngIf="item.inputType === 'dropdown'">
                            <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                                <label class="input-div" for="{{item.customization}}"
                                    [class.disabled]="datalabelpattern.test(item.className)?isdatalabel:(legendpattern.test(item.className)?islegend:FirstColumnpattern.test(item.className)?isFirstColumn:FirstRowpattern.test(item.className)?isFirstRow: false)"
                                    [innerHTML]="getCustomization(item)"> 
                                    <img *ngIf="item.customization === 'Trendline : ' || item.customization === 'Trend Area : '" 
                                            src="/assets/images/common/Config.svg" 
                                            alt="Customization Icon" 
                                            class="customization-icon"  (click)="showExpandPopupFun()"/>
                                </label>
                                <select #selectElement id="{{item.customization}}" class="dropdown"
                                    [style]="iscustomWidgetIcon && item.id=='Info Button'?'left:10vh':''"
                                    (change)="customWidgetIcon($event,item.id);qudarentcolorset($event,item);callCustomization($event,item)"
                                    [disabled]="datalabelpattern.test(item.className)?isdatalabel:(legendpattern.test(item.className)?islegend:FirstColumnpattern.test(item.className)?isFirstColumn:FirstRowpattern.test(item.className)?isFirstRow: false)">
                                    <option class="option" *ngFor="let option of item.options" [value]="option.value"
                                        [selected]="(item.selectedValue==option.label)?option.label:''">
                                        {{option.label}}</option>
                                </select>
                            </div>
                            <!-- ;loadedComponent[item.func]($event,item.id) -->
                        </ng-container>
                        <ng-container *ngIf="item.inputType==='textArea'" style="display: flex; ">
                            <div style="display:inherit;align-items: flex-start;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                                <label class="input-div" for="{{item.customization}}"
                                    [innerHTML]="getCustomization(item)"></label>
                                <div style="width: 54%;">
                                    <!-- Rich Text Formatting Toolbar -->
                                    <div class="rich-text-toolbar">
                                        <button type="button" 
                                                class="format-btn" 
                                                (click)="formatText('bold')" 
                                                [class.active]="isFormatActive('bold')"
                                                title="Bold">
                                            <strong>B</strong>
                                        </button>
                                        <button type="button" 
                                                class="format-btn" 
                                                (click)="formatText('italic')" 
                                                [class.active]="isFormatActive('italic')"
                                                title="Italic">
                                            <em>I</em>
                                        </button>
                                        <button type="button" 
                                                class="format-btn" 
                                                (click)="insertLineBreak()" 
                                                title="Line Break">
                                            ↵
                                        </button>
                                        <!-- <span class="char-count" 
                                              [class.warning]="getCharacterCount() > 250"
                                              [class.danger]="getCharacterCount() > 280">
                                            {{getCharacterCount()}}/300 
                                        </span> -->
                                    </div>
                                    <!-- Rich Text Editor -->
                                    <div 
                                        #richTextEditor
                                        class="rich-text-editor"
                                        contenteditable="true"
                                        (input)="onRichTextChange($event)"
                                        (paste)="onPaste($event)"
                                        (keydown)="onKeyDown($event)"
                                        (keyup)="updateButtonStates()"
                                        (mouseup)="updateButtonStates()"
                                        (focus)="onEditorFocus()"
                                        role="textbox"
                                        aria-multiline="true">
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="item.inputType==='textArea1'" style="display: flex; ">
                            <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh"
                                [style]="i%2==0?'background-color:rgba(0,0,0,0.03)':'background-color:transparent'">
                                <label class="input-div" for="{{item.customization}}"
                                    [innerHTML]="getCustomization(item)"></label>
                                <!-- <div style="margin-left: auto;    margin-right: 1.2em;"> -->
                                <div style="width: 54%;">
                                    <!-- <input type="text" id="{{item.customization}}" [(ngModel)]="customWidgetIcontext"
                                [placeholder]="customWidgetIcontext" class="dropdown"> -->
                                    <textarea maxlength="150" class="info-btn-text-area" rows="5" cols="15"
                                        placeholder="" [(ngModel)]="item.value" (keypress)="restrictInput($event,$event,item)" (input)="validateNumber($event, item, '')"></textarea>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="checkboxes-container2">
                    <!-- <div class="checkbox-div" *ngFor="let item of items; let i = index" style="display: flex;"
                        [style]="item.inputType === 'text'?'flex-direction: unset;':''">
                        <ng-container *ngIf="item.inputType === 'checkbox'"
                            [style]="i%2==0?'background-color:grey':'background-color:transparent'">
                            <input type="checkbox" class="checkbox-radio" id="{{item.customization}}"
                                (click)="checkBoxesClicked($event,item)" [checked]="item.selectedValue">
                            <label for="{{item.customization}}" (click)="checkBoxesClicked($event,item)"
                                class="checkbox-label">{{item.customization.replace(" : ","")}}</label><br>
                        </ng-container>
                    </div> -->
                 <div style="display:inherit;align-items: center;width:100%;padding-top:0.7vh;padding-bottom:0.7vh" 
         *ngIf="items && items.length > 0 && hasCheckboxItems()">
                        <label class="input-div" style="width: 40%;" for="Additional Features : ">Additional Features : </label>
                        <div class="additional-features-dropdown" (mouseleave)="isAdditionalDropdownOpen=false">
                            <!-- (mouseleave)="isAdditionalDropdownOpen=false" -->
                            <div class="additonal-drop-down" *ngIf="isAdditionalDropdownOpen">
                                <div class="item-container" *ngFor="let item of items"
                                    [ngClass]="{'selected':item.checked||item.selectedValue}"
                                    [style]="item.inputType === 'checkbox'?'display:flex':'display:none'">
                                    <input type="checkbox" class="checkbox-radio" id="{{item.customization}}"
                                        (click)="checkBoxesClicked($event,item)" [checked]="item.checked||item.selectedValue">
                                    <label for="{{item.customization}}" (click)="checkBoxesClicked($event,item)"
                                        class="checkbox-label">{{item.customization.replace(" : ","")}}</label><br>
                                </div>
                            </div>
                            <button class="drop-toggle btn flat" (click)="toggleAdditionaldropdown()">
                                <span class="selectText">{{additonalfeatureStatus()}}</span>
                                <!-- <span class="selectText"
                                    *ngIf=".length==1">{{item.checkedList[0].option}}</span>
                                <span class="selectText"
                                    *ngIf="item.checkedList.length>1">{{"Multiple"}}</span> -->
                                <p class="fa"><img class="downarrow"
                                        src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></p>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <!-- <div class="customization-description">
          <div class="customization-description-txt"><span style="color:red">(*)</span> Applicable only in ppt </div>
          <div class="customization-description-txt"><span style="color:red">(#)</span> Applicable only in highcharts  </div>
          <div class="customization-description-txt"><span style="color:red">($)</span> Screengrab</div>
        </div> -->
            <!-- <div class="download-btn CPS" (click)="downloadSourceCode()">
          <span class="arrow-down">&#8595;</span> Download
          Screengrab
        </div> -->
        </div>
    </div>
</div>

<ng-container *ngIf="showExpandPopup">
    <div class="overlay"></div>
    <app-output-popup *ngIf="showExpandPopup" [popUpParameter]="''" [snapProduct]="'custom'"
        [visualization]="'Line Chart'" [brandList]="" [metricList]="" [brandList]="" [trendLineView]=""  [id]="" [customData]="" [item]=""
        (dataEventTrend)="hide($event)"></app-output-popup>
    <!-- [DataLabelOn]="DataLabelOn" [Top10Toggle]="Top10Toggle"  [trendData]="data" [id]="id" [height]="height" -->

</ng-container>

<app-shared-popup-snapshot *ngIf="showErrorPopUp" [showErrorPopUp]="showErrorPopUp"
    [errorheaderTitle]="errorheaderTitle" [popUpParameter]="errorheaderTitle" [popUpMessage]="popUpMessage"
    (closeErrorPopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>

<app-shared-popup-snapshot *ngIf="showConfirmationPopUp" [showConfirmationPopUp]="showConfirmationPopUp"
    [errorheaderTitle]="errorheaderTitle" [popUpParameter]="'Confirmation'" [popUpMessage]="popUpMessage"
    (closeErrorPopUp)="onCloseIconClick($event)"
    (closeConfirmationPopUp)="onConfirmationClick($event)"></app-shared-popup-snapshot>